// extracted by mini-css-extract-plugin
export default {"fullscreen":"Gk5hDF4XdFnGvAlqMqJJ","placeHolderShimmer":"Q0ctO4jZRqJmpNx7sbvk"};